import type { CSSProperties } from "react";
import { appConfig } from "../config/env";

/** Non-production only — helps QA confirm which build is loaded. */
export default function EnvBadge() {
  if (appConfig.isProduction) return null;

  const styles: CSSProperties = {
    position: "absolute",
    top: 8,
    left: 8,
    zIndex: 20,
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    padding: "3px 7px",
    borderRadius: 6,
    color: "#fff",
    background: appConfig.isUat ? "#7C3AED" : "#2563EB",
    pointerEvents: "none",
    boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
  };

  return <div style={styles}>{appConfig.env}</div>;
}
